import React, { useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import "./Navbar.css";
import { FaFacebook, FaInstagram, FaLine } from "react-icons/fa";
import {
  BiBookOpen,
  BiFile,
  BiGroup,
  BiHomeAlt,
  BiInfoCircle,
  BiMap,
  BiMedal,
  BiNews,
  BiVideo,
} from "react-icons/bi";
import logo from "../img/small.png";
import { NavLink } from "react-router-dom";
import {
  HiOutlineHome,
  HiHome,
  HiOutlineUsers,
  HiUsers,
  HiOutlineBookOpen,
  HiBookOpen,
  HiFilm,
  HiOutlineFilm,
  HiOutlineInformationCircle,
  HiInformationCircle,
  HiNewspaper,
  HiOutlineNewspaper,
  HiMapPin,
  HiOutlineMapPin,
  HiAcademicCap,
  HiOutlineAcademicCap,
  HiSquares2X2,
  HiOutlineSquares2X2,
} from "react-icons/hi2";

export default function Navbar() {
  const [navOpen, setNavOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);
  //navbar scroll when active state
  const [navbar, setNavbar] = useState(false);

  //navbar scroll changeBackground function
  const changeBackground = () => {
    console.log(window.scrollY);
    if (window.scrollY >= 66) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    changeBackground();
    // adding the event when scroll change background
    window.addEventListener("scroll", changeBackground);
  });

  const item = [
    {
      name: "Home",
      href: "/",
      icon: HiOutlineHome,
      activeIcon: HiHome,
    },
    {
      name: "Our Course",
      href: "/course",
      icon: HiOutlineBookOpen,
      activeIcon: HiBookOpen,
    },
    {
      name: "Teaching Example",
      href: "/teaching-example",
      icon: HiOutlineFilm,
      activeIcon: HiFilm,
    },
    {
      name: "Our Teams",
      href: "/our-team",
      icon: HiOutlineUsers,
      activeIcon: HiUsers,
    },
    {
      name: "About us",
      href: "/about-us",
      icon: HiOutlineInformationCircle,
      activeIcon: HiInformationCircle,
    },
    {
      name: "Blog & News",
      href: "/blogs",
      icon: HiOutlineNewspaper,
      activeIcon: HiNewspaper,
    },
    {
      name: "Student Tools",
      href: "/student-tools",
      icon: HiOutlineSquares2X2,
      activeIcon: HiSquares2X2,
    },
    {
      name: "Our Success",
      href: "/success",
      icon: HiOutlineAcademicCap,
      activeIcon: HiAcademicCap,
    },
    {
      name: "Contact us",
      href: "/contact-us",
      icon: HiOutlineMapPin,
      activeIcon: HiMapPin,
    },
  ];

  return (
    <>
      <nav
        className={
          navbar
            ? "change fixed top-0 z-50 flex w-full justify-between px-5 sm:py-2 sm:px-12 xl:px-5 2xl:px-12"
            : "fixed top-0 z-50 flex w-full justify-between px-5  sm:py-2 sm:px-12 xl:px-5 2xl:px-12"
        }
        id="bg"
      >
        <div className="flex items-center">
          <NavLink to="/">
            <img src={logo} className="w-3/4 sm:w-auto" alt="" />
          </NavLink>
        </div>
        <div className="hidden items-center xl:flex">
          {item.map((item) => (
            <NavLink
              className={({ isActive }) => (isActive ? "current" : "normal")}
              to={item.href}
            >
              <span className="">{item.name}</span>
            </NavLink>
          ))}
        </div>
        <div className="hidden items-center text-xl 2xl:flex">
          <a
            href="https://www.facebook.com/GalileoTutor"
            target="_blank"
            rel="noreferrer"
          >
            <FaFacebook className=" text-gray-800" />
          </a>
          <a
            href="https://www.instagram.com/galileo_tutor/"
            target="_blank"
            rel="noreferrer"
          >
            <FaInstagram className="text-gray-800" />
          </a>
          <a
            href="https://liff.line.me/1645278921-kWRPP32q/?accountId=galileo_tutor"
            target="_blank"
            rel="noreferrer"
          >
            <FaLine className="  text-gray-800" />
          </a>
        </div>
        <div
          className="menu-toggle xl:hidden"
          onClick={() => setNavOpen(!navOpen)}
        >
          <div className={navOpen ? "hamBox hamBoxOpen" : "hamBox"}>
            <span className={navOpen ? "lineTop spinTop" : "lineTop"}></span>
            <span
              className={navOpen ? "lineBottom spinBottom" : "lineBottom"}
            ></span>
          </div>
        </div>
      </nav>
      <div
        className="nav-overlay fixed z-50"
        style={{
          right: navOpen ? "0" : "-100%",
          transitionDelay: navOpen ? "0s" : "0s",
        }}
      >
        <ul className="nav-links">
          {item.map((item, index) => (
            <li className="nav-item my-3">
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "active-link text-3xl font-bold text-purple-500"
                    : "text-3xl font-bold text-gray-800 "
                }
                to={item.href}
                onClick={() => {
                  setNavOpen(!navOpen);
                }}
                style={{
                  top: navOpen ? "0" : "120px",
                  transitionDelay: navOpen ? "0.8s" : "0s",
                }}
              >
                <item.activeIcon className="active-icon  mr-5 text-3xl" />

                <item.icon className="normal-icon  mr-5 text-3xl" />

                {item.name}
              </NavLink>
              <div className="nav-item-wrapper"></div>
            </li>
          ))}
        </ul>
        <div className="nav-footer">
          <div
            className="location mx-1"
            style={{
              bottom: navOpen ? "0" : "-20px",
              opacity: navOpen ? "1" : "0",
              transitionDelay: navOpen ? "1.2s" : "0s",
            }}
          >
            {/* <span className="font-bold">สำนักงาน กาลิเลโอ ติวเตอร์</span>
            <p>
              {" "}
              29/157 หมู่บ้านกลางเมือง สาทร - สุขสวัสดิ์ ซอยสุขสวัสดิ์ 39
              ต.บางพึ่ง อ.พระประแดง 10130
            </p> */}
          </div>

          <div className="nav-social-media">
            <ul>
              <li>
                <a
                  className="mx-3 text-4xl"
                  href="https://www.facebook.com/GalileoTutor"
                  target="_blank"
                  style={{
                    bottom: navOpen ? "0" : "-20px",
                    opacity: navOpen ? "1" : "0",
                    transitionDelay: navOpen ? "1.2s" : "0s",
                  }}
                >
                  <FaFacebook />
                </a>
              </li>
              <li>
                <a
                  className="mx-3 text-4xl"
                  href="https://www.instagram.com/galileo_tutor/"
                  target="_blank"
                  style={{
                    bottom: navOpen ? "0" : "-20px",
                    opacity: navOpen ? "1" : "0",
                    transitionDelay: navOpen ? "1.2s" : "0s",
                  }}
                >
                  <FaInstagram />
                </a>
              </li>
              <li>
                <a
                  className="mx-3 text-4xl"
                  href="https://liff.line.me/1645278921-kWRPP32q/?accountId=galileo_tutor"
                  target="_blank"
                  style={{
                    bottom: navOpen ? "0" : "-20px",
                    opacity: navOpen ? "1" : "0",
                    transitionDelay: navOpen ? "1.2s" : "0s",
                  }}
                >
                  <FaLine />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
